import { Field } from 'Util/Query';

/** @namespace Pwa/Query/ProductAttachments/Query */
export class ProductAttachmentsQuery {
    getProductAttachmentsQuery(product_sku) {
        return new Field('products')
            .addArgument('filter', 'ProductAttributeFilterInput!', { sku: { eq: product_sku } })
            .addField(
                new Field('items').addField(
                    new Field('mw_attachments').addField(
                        new Field('items').addFieldList(['icon_type', 'name', 'url', 'id'])
                    )
                )
            );
    }
}

export default new ProductAttachmentsQuery();
